export default {
  app: {
    title: 'TimeOnline',
    navigation: {
      menu: 'Menu',
      dashboard: 'Tableau de bord',
      changes: 'Changements',
      reports: 'Rapports',
      admin: 'Admin',
      records: 'Relevés',
      placementActivity: "Activités d'embauche",
      advancedSearch: 'Recherche avancée',
      assignments: 'Mandats',
      permPlacements: 'Embauches permanentes',
      timeSheets: 'Feuilles de temps',
      expenses: 'Dépenses',
      payrollOverviews: 'Aperçus de paie',
      contractors: 'Contractuels',
      clients: 'Clients',
      clientContacts: 'Personnes-ressources du client',
      purchaseOrders: 'Bons de commande',
      suppliers: 'Fournisseurs',
      supplierContacts: 'Coordonnées du fournisseur',
      tesEmployees: 'Employés de TES',
      users: 'Utilisateurs',
      recent: 'Récents',
      more: 'Plus',
      help: 'Aide',
      userGuides: "Guide d'utilisation",
      emailSupport: 'Assistance par courriel (support@timeonline.com)',
      profile: 'Profil',
      preferences: 'Préférences',
      logout: 'Fermer la session',
      quickSearch: 'Recherche rapide',
      depositSlips: 'Bordereaux de dépôt',
      home: 'Accueil',
      english: 'en',
      french: 'fr'
    },
    homePage: {
      welcome: 'Bonjour {userName}, bienvenue à TimeOnline!',
      lastLogin: 'Dernière ouverture de session à :',
      firstLogin: 'Ceci est votre première ouverture de session',
      pageDisplays: 'Cette page affiche tous les {displayTypes} {displayObjects}',
      unreadCount: 'Vous avez {count} messages non lus',
      displays: 'Cette page affiche tous les',
      sysAdminBlurb: 'activité récente (non générée par le système)',
      title: 'Accueil',
      listing: {
        labels: {
          contractor: 'Contractuel',
          client: 'Client',
          startDate: 'Début',
          endDate: 'Clôture',
          totalHours: 'Heures',
          totalDays: 'Jours',
          status: 'Statut',
          totalAmount: 'Montant'
        }
      }
    },
    pageFooter: {
      forHelp: "Besoin d'aide? Envoyez un courriel.",
      supportEmail: 'support@timeonline.com',
      copyright: 'Tous droits réservés',
      copyrightAddress: 'https://www.tes.net/',
      copyrightName: 'The Employment Solution',
      copyrightYears: `${new Date().getFullYear()}`
    },
    help: {
      title: 'Page Aide',
      forgotUsername: "Nom d'utilisateur oublié?",
      forgotPassword: 'Mot de passe oublié ?',
      forgotUsernameBlurb:
        "Saisissez l'adresse électronique à laquelle nous envoyons vos notifications. Nous vous enverrons votre nom d'utilisateur.",
      forgotPasswordBlurb:
        "Entrez l'adresse électronique à laquelle nous envoyons vos notifications. Nous vous enverrons votre mot de passe.",
      forgotPwDefault: "Courriel ou Nom d'utilisateur",
      forgotUsernameDefault: 'Entrez votre adresse électronique',
      changeRequestSuccessMessage:
        'Veuillez vérifier votre boîte de réception et utiliser le lien que nous vous avons envoyé pour réinitialiser votre mot de passe.',
      changeRequestErrorMessage:
        "Désolé, nous n'avons rien au nom de {usernameOrEmail} dans nos dossiers",
      passwordChangeSuccess:
        "Votre mot de passe a été modifié. Retournez à l'ouverture de session et connectez-vous avec votre nouveau mot de passe",
      passwordChangeError: 'Oups, quelque chose ne va pas. Réactualisez la page et réessayez.'
    }
  },
  login: {
    userName: "NOM D'UTILISATEUR",
    password: 'MOT DE PASSE',
    pleaseLogIn: 'Ouverture de session',
    passwordReset: 'Réinitialisation du mot de passe',
    submit: 'Ouvrir une session',
    errors: {
      badCredentials:
        "Impossible d'ouvrir une session. Le nom d'utilisateur ou le mot de passe est erroné.",
      loginAgain: 'Votre session a expiré, veuillez vous reconnecter',
      loginFirst: "Vous devez d'abord vous connecter"
    }
  },
  components: {
    select: {
      defaults: {
        placeholder: 'Choisir',
        multiSelectLabel: 'Sélectionné'
      }
    },
    tolErrors: {
      defaults: {
        message: 'Il y a 1 erreur | Il y a {count} erreurs'
      },
      moreItems: '|| ...et {count} autres erreurs'
    },
    confirmModal: {
      defaults: {
        message: 'Voulez-vous vraiment continuer?',
        continue: 'Continuer',
        cancel: 'Annuler',
        comment: 'Commentaire',
        okay: "D'accord",
        yes: 'Oui',
        no: 'Non'
      }
    }
  },
  timeSheet: {
    actions: {
      saveAsPdf: 'Sauvegarder en PDF',
      save: 'Sauvegarder',
      submit: 'Soumettre',
      approve: 'Approuver',
      reject: 'Rejeter',
      reopen: 'Réouvrir',
      viewExpense: 'Voir les dépenses',
      createExpense: 'Créer une dépense',
      process: 'Traiter'
    },
    labels: {
      timeSheet: 'Feuille de temps',
      referenceNumber: 'Numéro de référence',
      status: 'Statut',
      contractor: 'Contractuel',
      client: 'Client',
      assignment: 'Mandat',
      approvers: 'Approbateurs',
      comment: 'Commentaire',
      period: 'Période',
      endClient: 'Client final',
      payrollNumber: 'Matricule',
      branch: 'Succursale',
      notes: 'Remarques',
      none: 'Aucun'
    },
    placeholders: {
      commentsPlaceholder: 'Veuillez noter votre commentaire ici'
    }
  },
  timeSheets: {
    listing: {
      title: 'Feuilles de temps',
      actions: {
        titleAll: 'Toutes les feuilles de temps',
        titleFiltered: 'Feuilles de temps filtrées',
        titleYour: 'Vos feuilles de temps',
        view: 'Visualiser',
        exportToXlsx: 'Exporter vers XLSX'
      },
      labels: {
        referenceNumber: 'Numéro de référence',
        payrollNumber: 'No de paie',
        assignment: 'Mandat',
        client: 'Client',
        contractor: 'Contractuel',
        startDate: 'Début',
        endDate: 'Clôture',
        totalHours: 'Heures',
        totalDays: 'Jours',
        status: 'Statut',
        modifiedBy: 'Modification par',
        approveTimeSheets: 'Approuver les feuilles de temps',
        rejectTimeSheets: 'Rejeter les feuilles de temps',
        bulkPdf: 'Lot de PDF',
        comment: 'Commentaire'
      },
      filters: {
        title: 'Filtrer les feuilles de temps',
        startRange: 'Plage de début',
        endRange: 'Plage de fin',
        dateRangeLabel: 'La date de fin se situe entre',
        assignment: {
          all: 'Tous les mandats'
        },
        contractor: {
          all: 'Tous les contractuels'
        },
        status: {
          all: 'Tous les statuts',
          plural: 'Statuts'
        }
      },
      noResultsMessage: 'Aucune feuille de temps ne correspond à ce filtre',
      alertMessage:
        'Aucune feuille de temps ne correspond au statut {status} | Une feuille de temps correspond au statut {status} |  {count} feuilles de temps correspondent au statut {status}.',
      dialogs: {
        rejectTimeSheetsConfirmationDialog: {
          title: 'Rejeter les feuilles de temps',
          content: 'Voulez-vous rejeter les feuilles de temps sélectionnées?'
        },
        bulkApproveRejectConfirmationDialog: {
          confirmMessage: 'Voulez-vous vraiment {message} ce lot de feuilles de temps?',
          continue: 'Continuer',
          cancel: 'Annuler'
        }
      },
      errors: {
        retrieveTimeSheets: "Une erreur s'est produite dans la récupération des feuilles de temps",
        retrieveAssignments: "Une erreur s'est produite dans la récupération des mandats à filtrer",
        retrieveContractors:
          "Une erreur s'est produite dans la récupération de la liste des contractuels à filtrer",
        retrieveStatusCount:
          "Une erreur s'est produite dans la récupération en fonction de l'état des dossiers",
        bulkApproveRejectDisallowed:
          "Il n'est pas permis d'appliquer cette action à une ou plusieurs des feuilles de temps sélectionnée(s)",
        bulkApproveRejectFailed: 'Une erreur est survenue dans la mise à jour des feuilles de temps'
      }
    },
    details: {
      editTitle: 'Modifier les feuilles de temps',
      reviewTitle: 'Revoir les feuilles de temps',
      timeSheet: 'Feuilles de temps',
      endClientConfirm: 'Client final',
      errors: {
        retrieveTimeSheet:
          'Une erreur est survenue dans le téléchargement de la feuille de temps à partir du serveur',
        retrieveAttachments:
          'Une erreur est survenue dans le téléchargement des pièces jointes à la feuille de temps à partir du serveur',
        save: 'Une erreur est survenue dans la sauvegarde de la feuille de temps',
        reopen: 'Une erreur est survenue dans la réouverture de la feuille de temps',
        approverAction: "Une erreur est survenue dans l'exécution de cette commande",
        commentMandatory: "Il faut fournir un commentaire lorsqu'on rejette une feuille de temps",
        expense:
          'Une erreur est survenue dans la récupération ou la création du rapport de dépenses',
        confirmIbmEndClient: 'Il faut confirmer ou remplacer le client final',
        timeSheetHistory: "Une erreur est survenue dans la récupération de l'historique"
      },
      showHistory: "Montrer l'historique",
      hideHistory: "Masquer l'historique"
    },
    history: {
      title: 'Historique',
      version: 'Numéro de version {num}'
    }
  },
  attachments: {
    title: 'Pièces jointes',
    labels: {
      invoice: 'Facture',
      other: 'Autre',
      drop: 'Déposez votre fichier ici ou',
      select: 'sélectionnez-le de votre ordinateur',
      selectOnly: 'Sélectionnez un fichier de votre ordinateur',
      allowedFiles: 'pdf, xlsx, docx, jpg, gif, png, tif, zip'
    },
    errors: {
      forbiddenView: "Vous n’avez pas l'autorisation de consulter cette pièce jointe",
      forbiddenDelete: "Vous n’avez pas l'autorisation de supprimer cette pièce jointe",
      notFound: 'Pièce jointe introuvable',
      uploadFailed: 'Impossible de joindre les fichiers',
      unexpected: 'Erreur de {status} inattendue',
      unsupported: 'Type de fichier non accepté'
    }
  },
  expense: {
    actions: {
      saveAsPdf: 'Sauvegarder en PDF',
      save: 'Sauvegarder',
      submit: 'Soumettre',
      approve: 'Approuver',
      reject: 'Rejeter',
      reopen: 'Ouvrir à nouveau',
      add: 'Ajouter une entrée',
      process: 'Traiter'
    },
    labels: {
      expense: 'Dépense',
      referenceNumber: 'Numéro de référence',
      status: 'Statut',
      contractor: 'Contractuel',
      client: 'Client',
      assignment: 'Mandat',
      approvers: 'Approbateurs',
      comment: 'Commentaire',
      period: 'Période',
      payrollNum: 'No de paie'
    },
    placeholders: {
      commentsPlaceholder: 'Veuillez noter votre commentaire ici',
      selectDate: 'Sélectionner la date'
    },
    errors: {
      amountNotNumeric: 'Montant doit être en chiffres mais est présenté en {avalue}',
      approverAction: "Une erreur est survenue dans l'exécution de cette action",
      retrieveExpense:
        'Une erreur est survenue dans le téléchargement du rapport de dépenses à partir du serveur',
      retrieveAttachments:
        'Une erreur est survenue dans le téléchargement des pieces jointes au rapport de dépenses à partir du serveur',
      save: "Une erreur est survenue' dans la sauvegarde du rapport de dépenses",
      reopen: 'Une erreur est survenue dans la réouverture du rapport de dépenses',
      commentMandatory: "Il faut fournir un commentaire lorsqu'on rejette un rapport de dépenses",
      expense: 'Impossible de générer ou récupérer un rapport de dépenses',
      invalidEntries: 'Manque date ou montant à certaines entrées',
      retrieveHistory: 'Une erreur est survenue dans la récupération des historiques'
    },
    history: {
      title: 'Historique',
      version: 'Numéro de version {num}'
    }
  },
  expenses: {
    listing: {
      title: 'Dépenses',
      actions: {
        titleAll: 'Toutes les dépenses',
        titleFiltered: 'Dépenses filtrées',
        titleYour: 'Vos dépenses',
        view: 'Visualiser',
        exportToXlsx: 'Exporter en XLSX'
      },
      labels: {
        referenceNumber: 'Numéro de référence',
        payrollNumber: 'No de paie',
        assignment: 'Mandat',
        client: 'Client',
        clientName: 'Client' /*temporary fix to solve I18n warnings */,
        contractor: 'Contractuel',
        startDate: 'Début',
        endDate: 'Clôture',
        totalAmount: 'Montant',
        status: 'Statut',
        approveExpenses: 'Approuver les dépenses',
        rejectExpenses: 'Rejeter les dépenses',
        bulkPdf: 'Lot de PDF'
      },
      filters: {
        title: 'Filtrer les dépenses',
        startRange: 'Plage de début',
        endRange: 'Plage de fin',
        dateRangeLabel: 'Date de complétion entre',
        assignment: {
          all: 'Tous les mandats'
        },
        contractor: {
          all: 'Tous les contractuels'
        },
        status: {
          all: 'Tous les statuts',
          plural: 'Statuts'
        }
      },
      noResultsMessage: 'Aucune dépense ne correspond à ce filtre.',
      alertMessage:
        "Vous n’avez aucune dépense ayant le statut {status}' | 'Vous avez {count} dépense(s) ayant le statut {status}",
      errors: {
        retrieveExpenses: 'Une erreur est survenue dans la récupération de la liste des dépenses',
        retrieveAssignments: 'Une erreur est survenue dans la récupération des mandats à filtrer',
        retrieveContractors:
          'Une erreur est survenue dans la récupération de la liste des contractuels à filtrer',
        retrieveStatusCount:
          "Une erreur est survenue dans la récupération en fonction de l'état des dossiers"
      }
    },
    details: {
      editTitle: 'Modifier la dépense',
      reviewTitle: 'Revoir la dépense',
      expense: 'Dépense',
      dropLabel: 'Déposez votre fichier ici ou',
      selectLabel: 'sélectionnez-le de votre ordinateur',
      selectOnlyLabel: 'Sélectionnez le fichier de votre ordinateur',
      errors: {
        commentMandatory: "Il faut fournir un commentaire lorsqu'on rejette un rapport de dépenses"
      },
      showHistory: "Montrer l'historique",
      hideHistory: "Masquer l'historique"
    }
  },
  suppliers: {
    labels: {
      attachment: 'Pièce jointe',
      history: 'Historique',
      contacts: 'Coordonnées',
      contractors: 'Contractuels',
      details: 'Détails',
      addresses: 'Adresses',
      newSupplier: 'Nouveau fournisseur'
    },
    contractors: {
      payroll_num: 'No de paie',
      name: 'Nom',
      entity: 'Entité commerciale',
      pay_to_name: "À l'ordre de",
      email: 'Courriel',
      referenceNumber: 'Numéro de référence'
    },
    contacts: {
      referenceNumber: 'Numéro de référence',
      contactName: 'Nom',
      supplierName: 'Fournisseur',
      email: 'Courriel',
      phone: 'Téléphone'
    },

    filterPreference: {
      active: 'Actif',
      inactive: 'Non actif',
      both: 'Les deux'
    },
    listing: {
      title: 'Fournisseurs',
      all: 'Tous les fournisseurs',
      errors: {
        retrieveSuppliers:
          'Une erreur est survenue dans la récupération de la liste de fournisseurs'
      },
      labels: {
        name: 'Nom',
        defaultAddress: 'Adresse par défaut',
        heldCheque: 'Chèques retenus pour clients',
        referenceNumber: 'Numéro de référence'
      },
      filters: {
        title: 'Filtre des Fournisseur',
        all: 'Sélectionner les fournisseurs'
      },
      actions: {
        new: 'Nouveau fournisseur',
        exportToExcel: 'Exporter vers Excel',
        exportAll: 'Tout exporter',
        exportPage: 'Exporter la page'
      }
    },
    details: {
      errors: {
        retrieveSupplier: 'Une erreur est survenue dans la récupération de la liste de fournisseurs'
      },
      title: 'Fournisseurs',
      name: 'Nom du fournisseur',
      clientName: 'Clients Held Cheques',
      gst: 'TPS',
      qst: 'TVQ',
      hst: 'TVH',
      is_active: 'Actif'
    }
  },
  bulk: {
    dialogs: {
      approveRejectConfirmationDialog: {
        confirmMessage: "Voulez-vous vraiment {message} ce lot d'éléments sélectionnés?",
        continue: 'Continuer',
        cancel: 'Annuler',
        okay: 'Okay'
      }
    },
    labels: {
      totalSelected: 'Quantité sélectionnée'
    },
    actions: {
      approve: 'Approuver',
      reject: 'Reject',
      saveAsPdf: 'Sauvegarder en PDF'
    },
    errors: {
      approveRejectDisallowed:
        "Impossible d'appliquer cette action à au moins un des éléments sélectionnés",
      approveRejectFailed: 'Une erreur est survenue dans la mise à jour des éléments',
      sameClientError: 'Sélectionner {item} correspondant tous au même client'
    }
  },
  notifications: {
    listing: {
      title: 'Notifications',
      listingTitle: 'Notifications',
      noNotificationMessage: 'Aucune notification reçue',
      labels: {
        timeGenerated: 'Heure de production',
        generatedBy: 'Produit par',
        message: 'Message',
        referenceNumber: 'Numéro de référence'
      },
      errors: {
        retrieveNotifications: 'Une erreur est survenue dans la récupération des notifications',
        updateNotifications: 'Une erreur est survenue dans le téléchargement des notifications'
      }
    }
  },
  preferences: {
    listing: {
      title: 'Préférences',
      userTitle: 'Préférences de notifications de {username}',
      subTitle: 'Réger les préférences en matière de notifications',
      noPreferencesMessage: 'Vous n’avez pas réglé vos préférences en matière de notifications',
      labels: {
        object: 'Objet',
        action: 'Action',
        noticeType: "Type d'avis",
        inApp: 'Notification dans TimeOnline',
        email: 'Envoyer un courriel',
        labelStarter: "M'envoyer une notification si",
        is: 'est',
        for: 'pour',
        label: 'Type d’avis'
      }
    },
    errors: {
      retrievePreferences:
        'Une erreur est survenue dans la récupération des réglages des préférences en matière de notification',
      updatePreferences:
        'Une erreur est survenue dans la mise à jour des réglages des préférences en matière de notification',
      addPreference: 'Une erreur est survenue dans la création des réglages des préférences'
    }
  },
  profile: {
    titles: {
      title: "Profil d'utilisateur",
      action: 'Action',
      item: 'Élément',
      referenceNum: 'No de référence',
      userDetails: "Infos de l'utilisateur",
      recentlyAccessed: 'Récemment accédé',
      recentActions: 'Actions récentes',
      recentlyViewed: 'Récemment consulté',
      type: 'Type',
      timestamp: 'Horodatage',
      ipAddress: 'Adresse IP'
    },
    labels: {
      userName: "Nom d'utilisateur",
      roles: 'Rôles',
      email: 'Courriel',
      altEmail: 'mod. courriel',
      phones: 'Téléphones',
      branch: 'Succursale',
      payto: 'Payer à',
      payroll: 'No de paie',
      entity: 'Entité commerciale',
      impersonate: "Emprunt d'identité",
      inactiveUser: 'Ouverture de session impossible car utilisateur inactif',
      notifications: 'Notifications',
      preferences: 'Préférences'
    },
    listing: {
      labels: {
        initiatedAt: 'Commencé à',
        objectType: 'Type d’objet',
        action: 'Action',
        ipAddress: 'Adresse IP'
      }
    }
  },
  pagination: {
    labels: {
      perPage: 'Relevés par page',
      showing: 'Affichage',
      of: 'de'
    }
  },
  assignment: {
    labels: {
      details: 'Détails',
      contractorDetails: 'Contractuel',
      clientDetails: 'Client',
      stakeholdersDetails: 'Parties intéressées',
      miscDetails: 'Misc',
      timeSheets: 'Feuilles de temps',
      expenses: 'Dépenses',
      attachments: 'Pièces jointes',
      history: 'Historique',
      ibmExtraInfo: 'Précisions pour IBM',
      extraInfo: 'Précisions',
      comments: 'Commentaires',

      formLabels: {
        phone: 'Téléphone',
        email: 'Courriel',
        payrollNumber: 'No de paie',
        hst: 'TVH',
        backcheck: 'Vérification des antécédents',
        payTo: 'Payer à',
        entity: 'Entité commerciale',
        clientNumber: 'No de client',
        endClient: 'Client final',
        workOrderNumber: ' Work Order #',
        workAuthorization: 'WA',
        billTo: 'Facturer à',
        workLocation: 'Lieu de travail',
        poWo: 'Bon de travail | de commande',
        approvers: 'Approbateurs',
        accountManagers: 'Chargés de projet',
        viewers: 'Consultants autorisés',
        recruiters: 'Agents de recrutement',
        users: 'Utilisateurs',
        commissionOverrides: 'Surprimes',
        startDate: 'Date de début',
        endDate: 'Date de clôture',
        submittalPeriod: 'Période de remise',
        payPeriod: 'Période de paie',
        rebate: 'Réduction',
        burden: 'Charge',
        branch: 'Succursale',
        division: 'Division',
        department: 'Service',
        occupation: 'Occupation',
        payStubsOnline: 'Relevés de paie en ligne',
        timeSheetsSubmittal: 'Remise des feuilles de temps',
        expensesSubmittal: 'Remise des dépenses',
        referral: 'Indication de client',
        rates: 'Taux',
        rateType: 'Type de taux',
        payRate: 'Taux de rémunération',
        billRate: 'Taux de facturation au client',
        hourRange: 'Période de facturation (en h)',
        effectiveDate: "Date d'entrée en vigueur",
        submittalPeriodEffectiveDate: "Date d'entrée en vigueur de la nouvelle période de remise",
        hiringManager: 'Responsable du recrutement',
        scheduleF: 'Annexe F',
        assets: 'Biens prêtés',
        assetNumbers: 'Numéros des biens prêtés',
        endReasons: 'Raisons',
        ibmExtraInfo: 'Précisions pour IBM',
        hireType: 'Type d’embauche',
        skillType: 'Type de compétences',
        servicesType: 'Type de services',
        referralStatus: 'Type de recommandation',
        WOs_POs: 'WOs & POs',
        billingComments: 'Commentaire sur la facturation',
        paymentComments: 'Commentaire sur le paiement',
        generalComments: 'Commentaire général',
        createdComments: 'Info complémentaire',
        purchaseOrderEffectiveDate: "Date d'entrée en vigueur",
        payrollee: 'Salarié(e)',
        csaSow: 'CSA / SOW?',
        csaRrf: 'CSA / RRF'
      },
      validation: {
        setStartDateBeforeEffective:
          "Fixer date de début du mandat avant d'attribuer date d'entrée en vigueur",
        effectiveEarlierThanStartDate:
          "Date d'entrée en vigueur ne peut être avant date de début du mandat",
        effectiveOutsideAssignmentDates:
          "Date d'entrée en vigueur ne peut être hors des dates du mandat",
        required: 'Champ {field} obligatoire',
        accountManagerRequired: 'Il faut au moins un chargé de compte',
        recruiterRequired: 'Il faut au moins un agent de recrutement'
      }
    },
    history: {
      listing: {
        labels: {
          created_at: 'Date de modification',
          created_by_name: 'Modification par',
          status: 'Statut',
          created_comment: 'Commentaire'
        }
      }
    },
    details: {
      title: 'Mandat',
      errors: {
        retrieveAssignment: 'Une erreur est survenue dans la récupération du mandat',

        noAssignment: 'Aucun mandat n’a été sélectionné',
        processAssignment: 'ACTION INTERDITE : {message}',
        noRecords: 'Aucun {record} associé à ce mandat'
      },
      actions: {
        saveAsPdf: 'Sauvegarder en PDF'
      }
    }
  },
  assignments: {
    listing: {
      title: 'Mandats',
      labels: {
        referenceNumber: 'Numéro de référence',
        payrollNumber: 'Matricule',
        clientName: 'Client',
        contractorName: 'Contractuel',
        startDate: 'Début',
        stopDate: 'Fin',
        approvers: 'Approbateurs',
        branch: 'Succursale',
        status: 'Statut',
        approveAssignments: 'Approuver les mandats',
        rejectAssignments: 'Rejeter les mandats',
        bulkPdf: 'Lot de PDF',
        createTimesheet: 'Créer une feuille de temps',
        showTimeSheets: 'Afficher les feuilles de temps',
        hideTimeSheets: 'Masquer les feuilles de temps',
        showExpenses: 'Afficher les dépenses',
        hideExpenses: 'Masquer les dépenses',
        showAttachments: 'Afficher les pièces jointes',
        hideAttachments: 'Masquer les pièces jointes',
        showHistory: 'Afficher les historiques',
        hideHistory: 'Masquer les historiques'
      },
      filters: {
        title: 'Filtrer les mandats',
        startsBetweenLabel: 'Début entre le',
        startDateMin: 'Début de la plage de temps',
        startDateMax: 'Fin de la plage de temps',
        stopsBetweenLabel: 'Fin entre le',
        stopDateMin: 'Début de la plage de temps',
        stopDateMax: 'Fin de la plage de temps',
        status: {
          all: 'Tous les statuts',
          plural: 'Statuts'
        }
      },
      actions: {
        titleAll: 'Tous les mandats',
        titleFiltered: 'Mandats filtrés',
        exportToXlsx: 'Exporter vers XLSX'
      },
      errors: {
        retrieveAssignments: 'Une erreur est survenue dans la récupération de la liste des mandats',

        bulkApproveRejectFailed: 'Une erreur est survenue dans la mise à jour des mandats'
      },
      newAssignment: {
        title: 'Nouveau mandat'
      }
    }
  },
  statuses: {
    draft: 'Ébauche',
    submitted: 'Soumis',
    approved: 'Approuvé',
    processed: 'Traité',
    rejected: 'Rejeté',
    obsolete: 'Périmé',
    active_online: 'Actif en ligne',
    active_offline: 'Actif hors ligne',
    finished: 'Terminé',
    cancelled: 'Annulé',
    expired: 'Échu',
    received: 'Reçu'
  },
  dropdown: {
    noResult: 'Aucun résultat'
  },
  permPlacement: {
    details: {
      title: 'Embauche permanente',
      errors: {
        npPerm: "Pas d'embauche permanente",
        retrievePermPlacement: "Erreur dans la récupération de l'embauche permanente",
        userAlreadyAdded: "{user} {commission}  de l'{utilisateur} déjà ajoutée",
        originalDateAfterStart: 'Date de début initiale ne peut être après date de début',
        startDateBeforeOriginal: 'Date de début ne peut être avant date de début initiale'
      }
    },
    labels: {
      details: 'Détails',
      candidatePlaced: 'Embauche du candidat',
      lastName: 'Nom de famille',
      firstName: 'Prénom',
      clientDetails: 'Client',
      invoiceNum: 'Numéro de facture',
      salary: 'Salaire',
      findersPercentage: 'Pourcentage de l’intermédiaire',
      billingAmount: 'Montant facturé',
      currencyCode: 'Devise',
      billTo: 'Facturer à',
      taxesOnInvoice: 'Taxes sur facture',
      gst: 'TPS',
      hst: 'TVH',
      qst: 'TVQ',
      outsourceAmount: 'Montant en impartition',
      outsourcePaidTo: 'Impartition payée à',
      guarantee: 'Garantie',
      replacementTerm: 'Mandat de remplacement',
      paymentTerm: 'Modalités de paiement',
      withReplacement: 'Avec remplacement',
      otherAgreement: 'Autre entente',
      accountManagers: 'Chargés de projet',
      recruiters: 'Agents de recrutement',
      commissionOverrides: 'Surprimes',
      misc: 'Divers',
      branch: 'Succursale',
      division: 'Division',
      startDate: 'Date de début',
      originalStartDate: 'Date de début initiale',
      clientTransfer: 'Mutation du client',
      occupation: 'Occupation',
      tesShareOfSplit: 'Part de TES dans le fractionnement',
      or: 'or',
      splitDescription: 'Description du fractionnement',
      paymentTerms: 'Modalités de paiement',
      comments: 'Commentaires',
      outsourceAndSplit: 'Impartition avec fractionnement',
      stakeholdersDetails: 'Parties intéressées',
      miscDetails: 'Divers',
      history: 'historique',
      attachments: 'pièces jointes',
      currency: 'Devise'
    },
    listing: {
      title: 'Embauches permanentes',
      labels: {
        reference_number: 'Numéro de référence',
        invoice_number: 'No de facture',
        name: 'Nom',
        client_name: 'Client',
        start_date: 'Date de début',
        branch_name: 'Succursale',
        status: 'Statut'
      },
      actions: {
        titleAll: 'Toutes les embauches permanentes',
        titleFiltered: 'Embauches permanentes filtrées'
      },
      filters: {
        title: 'Filtrer les embauches permanentes',
        startsBetweenLabel: 'Début entre le',
        startDateMin: 'Début de la plage de temps',
        startDateMax: 'Fin de la plage de temps',
        status: {
          all: 'Tous les statuts',
          plural: 'Statuts'
        }
      },
      errors: {
        retrievePerms: 'Une erreur est survenue dans la récupération des embauches permanentes'
      }
    },
    history: {
      listing: {
        labels: {
          created_at: 'Date de modification',
          created_by_name: 'Modification par',
          status: 'Statut',
          start_date: 'Début',
          createdComment: 'Commentaire'
        }
      }
    },
    actionButtons: {
      save: 'SAUVEGARDER',
      submit: 'SOUMETTRE',
      process: 'TRAITER',
      reject: 'REJETER',
      cancel: 'ANNULER',
      obsolete: 'PÉRIMÉ',
      reopen: 'RÉOUVRIR',
      processSelected: 'PROCESSUS SÉLECTIONNÉ',
      rejectSelected: 'REJETÉ SÉLECTIONNÉ'
    }
  },
  contractor: {
    details: {
      title: 'Infos du contractuel',
      errors: {
        retrieveContractor:
          'Une erreur est survenue dans le téléchargement des infos du contractuel à partir du serveur'
      }
    },
    labels: {
      personalDetails: 'Informations personnelles',
      payrollNumber: 'No de paie',
      lastName: 'Nom de famille',
      firstName: 'Prénom',
      preferredName: 'Nom préféré',
      entityType: 'Type d’entité commerciale',
      emails: 'Courriels',
      phoneNumbers: 'Numéros de téléphone',
      address: 'Adresse',
      payToName: "À l'ordre de",
      line1: 'Ligne 1',
      line2: 'Ligne 2',
      city: 'Ville',
      postalCode: 'Code postal',
      province: 'Province',
      governmentNumbers: 'Matricules gouvernementaux',
      sin: 'NAS',
      expires: 'Expiration',
      ssn: 'SSN (É.-U.)',
      gst: 'TPS',
      qst: 'TVQ',
      hst: 'TVH',
      supportingDocuments: 'Pièces justificatives',
      aoda: 'LAPHO',
      signedFormOnFile: 'Formulaire signé archivé',
      orCode: 'ou code',
      backcheck: 'Vérification des antécédents',
      whmis: 'SIMDUT',
      whmisGhs: 'SIMDUT+SGH',
      healthAndSafety: 'Santé-sécurité',
      workplaceViolence: 'Violence au travail',
      miscDetails: 'Divers',
      cpp: 'RPC',
      contributing: 'Contribue',
      receiving: 'Reçoit',
      active: 'Actif',
      postalCodeVerified: 'Code postal vérifié',
      vaccinationStatus: 'Statut vaccinal',
      vaccinationDetails: 'Autres infos sur le statut vaccinal, au besoin',
      source: 'Source',
      sourceNote: 'Commentaire de la source',
      comments: 'Commentaires',
      externalNotes: 'Notes externes',
      history: 'Historique',
      attachments: 'Pièces jointes',
      newContractor: 'Nouveau contractuel',
      assignments: 'Mandats',
      contractor: 'Contractuel',
      client: 'Client',
      approvers: 'Approbateurs',
      startDate: 'Date de début',
      stopDate: 'Date de fin',
      branch: 'Succursale',
      status: 'Statut',
      referenceNumber: 'Numéro de référence',
      supplier: 'Fournisseur',
      effectiveDate: 'Date d’entrée en vigueur',
      userAccount: 'Compte d’utilisateur',
      invalidEffectiveDate:
        "Ne pas modifier l’entité ni l'entrée Payer à, car le contractuel a un mandat en cours"
    },
    history: {
      listing: {
        labels: {
          created_at: 'Date de modification',
          created_by_name: 'Modification par',
          payroll: 'No de paie',
          name: 'Nom',
          email: 'Courriel',
          entity: 'Entité commerciale',
          pay_to_name: "À l'ordre de",
          comment: 'Commentaire'
        }
      }
    }
  },
  contractors: {
    labels: {
      filter: 'Filtrer'
    },
    details: {
      errors: {
        save: 'Une erreur est survenue dans la sauvegarde du contractuel'
      }
    },
    actions: {
      exportToXlsx: 'Exporter vers XLSX'
    },
    listing: {
      title: 'Contractuels',
      labels: {
        reference_number: 'Numéro de référence',
        payroll_num: 'Matricule',
        payrollnums: 'Matricules',
        contractorName: 'Contractuel',
        entity: 'Entité commerciale',
        pay_to_name: "À l'ordre de",
        email: 'Courriel'
      },
      errors: {
        retrieveContractors:
          'Une erreur est survenue dans la récupération de la liste des contractuels'
      }
    }
  },
  tesEmployees: {
    filterPreference: {
      active: 'Actif',
      inactive: 'Inactif',
      both: 'Les deux'
    },
    labels: {
      history: 'Historique',
      attachment: 'Pièces jointes',
      personalDetails: 'Informations personnelles',
      commissionProfiles: 'Structures de commission',
      attachments: 'Pièces jointes',
      lastName: 'Nom de famille',
      firstName: 'Prénom',
      preferredName: 'Nom préféré',
      branch: 'Succursale',
      emails: 'Courriels',
      phoneNumbers: 'Numéros de téléphone',
      division: 'Division',
      commission_number: 'Numéro',
      description: 'Description',
      newTesEmployee: 'Nouvel employé TES',
      roles: 'çôles',
      userAccount: "Compte d'utilisateur"
    },
    details: {
      title: 'Employés de TES',
      errors: {
        retrieveTesEmployee:
          'Une erreur est survenue dans le téléchargement des détails concernant les employés de TES à partir du serveur',

        commissionError: 'Numéro de commission existe déjà'
      },
      info: {
        saveTesEmployee: "Mise à jour du dossier d'employé réussie",
        adminCanEdit:
          "Modification des rôles autorisée uniquement par un admnistrateur du système et à partir du compte de l'utilisateur",
        noRolesAdded: "Aucun rôle n'a été ajouté à cet utilisateur"
      }
    },
    listing: {
      filters: {
        title: 'Filtrer les employés',
        all: 'Sélectionner les employés'
      },
      title: 'Employés de TES',
      labels: {
        reference_number: 'Numéro de référence',
        tesEmployeeName: 'Nom',
        branch_name: 'Succursale',
        email: 'Courriel',
        roles: 'Rôles',
        commissions: 'No de commission'
      },
      actions: {
        titleAll: 'Tous les employés de TES'
      },
      errors: {
        retrieveTesEmployees:
          'Une erreur est survenue dans la récupération de la liste des employés de TES'
      }
    }
  },

  advancedSearch: {
    title: ' Recherche avancée',
    formWizard: {
      title: 'Sélectionner les critères de recherche',
      subTitle: 'sous-titre',
      firstTabTitle: 'Quels dossiers souhaitez-vous avoir?',
      secondTabTitle: "Champs d'entrée",
      thirdTabTitle: "N'afficher que ces champs"
    },
    fieldSelect: {
      showAllOptions: 'Afficher toutes les options'
    },
    actions: {
      printToPdf: 'Imprimer en tant que PDF',
      exportToExcel: 'Exporter vers Excel',
      exportPage: 'Exporter cette page',
      exportAll: 'Tout exporter'
    },
    errors: {
      notAllowed: 'Action non autorisée pour les éléments sélectionnés',
      unknown: 'Une erreur est survenue dans la mise à jour des éléments sélectionnés'
    },
    response: {
      success: 'réussi',
      bulkPdfGenerationNotification: 'PLe PDF apparaîtra sous le nouvel onglet'
    }
  },

  batchUpdateResults: {
    listing: {
      title: 'Résultat de la mise à jour par lots',
      successMessage: 'Les {tolObject} suivants ont été mis à jour',
      errorMessage: "Il a été impossible de faire la mise à jours d'au moin un des éléments",
      returnMessage:
        "Vous vous retrouvez sur cette page en raison de votre commande précédente. Veuillez retourner à l'autre page et faire la commande nécessaire pour obtenir le résultat désiré"
    }
  },

  dashboard: {
    title: 'Tableau de bord',
    charts: {
      activeAssignmentsTimeline: {
        title: 'Déroulement des mandats en cours',
        xAxisLabel: 'Année',
        yAxisLabel: 'Mandats en cours'
      },
      activeAssignmentsByBranch: {
        title: 'Mandats en cours par succursale',
        xAxisLabel: 'Succursale',
        yAxisLabel: 'Mandats en cours'
      },
      contractorTypeHeadCount: {
        title: 'Décompte des effectifs du contractuel - Mandats en cours',
        xAxisLabel: 'Décompte des effectifs',
        yAxisLabel: 'Type de contractuel'
      }
    }
  },
  clients: {
    listing: {
      title: 'Clients',
      all: 'Tous les clients',
      labels: {
        reference_number: 'Numéro de référence',
        name: 'Nom',
        address: 'Adresse par défaut',
        phone: 'Téléphone',
        credit_check: 'Vérification du crédit',
        type: 'Type',
        clientStatusFilter: 'Statut du client',
        clientTypeFilter: 'Type de client'
      },
      filters: {
        title: 'Filtrer les clients',
        clientStatuses: {
          both: 'Les deux',
          active: 'Actif',
          inactive: 'Inactif'
        },
        clientTypes: {
          both: 'Les deux',
          regular: 'Courant',
          endClient: 'Client final'
        }
      },
      actions: {
        new: 'Nouveau client',
        exportToExcel: 'Exporter vers Excel',
        exportAll: 'Tout exporter',
        exportPage: 'Exporter cette page'
      }
    }
  },
  client: {
    labels: {
      details: 'Détails',
      contacts: 'Coordonnées',
      addresses: 'Adresses',
      attachments: 'Pièces jointes',
      billingMethods: 'Modes de facturation',
      history: 'Historique',
      client: 'Client',
      clientName: 'Nom du client',
      clientType: 'Type',
      creditCheckDate: 'Date de vérification du crédit',
      clientProfile: 'Actif',
      assignmentRequirement: 'Associer un bon de travail/commande aux mandats',
      referenceNumber: 'Numéro de référence',
      lastName: 'Nom de famille',
      firstName: 'Prénom',
      preferredName: 'Nom préféré',
      email: 'Courriel',
      phoneNumber: 'Numéro de téléphone',
      paymentTerms: 'Modalités de paiement',
      paymentTermUnit: 'Unité',
      additionalComment: 'Autre commentaire'
    },
    history: {
      listing: {
        labels: {
          name: 'Nom',
          created_at: 'Date de modification',
          created_by_name: 'Modification par',
          type: 'Type',
          credit_check: 'Vérification de crédit'
        }
      }
    }
  },
  clientContact: {
    details: {
      clientContact: 'Personne-ressource du client'
    },
    labels: {
      details: 'Details',
      assignments: 'Mandats',
      firstName: 'Prénom',
      lastName: 'Nom de famille',
      email: 'Courriel',
      active: 'Actif',
      userAccount: "Compte d'utilisateur",
      client: 'Client',
      address: 'Adresse',
      line1: 'Ligne 1',
      line2: 'Ligne 2',
      city: 'Ville',
      province: 'Province',
      postalCode: 'Code postal',
      preferredName: 'Nom préféré',
      emails: 'Courriels',
      phoneNumbers: 'Numéros de téléphone',
      referenceNumber: 'Numéro de référence',
      payrollNumber: 'No de paie',
      contractor: 'Contractuel',
      users: 'Utilisateurs',
      startDate: 'Date de début',
      stopDate: 'Date de fin',
      branch: 'Succursale',
      status: 'Statut',
      approvers: 'Approbateurs',
      newClientContact: 'Nouvelle personne-ressource du client'
    }
  },
  clientContacts: {
    listing: {
      labels: {
        reference_number: 'Numéro de référence',
        clientContactName: 'Nom',
        client: 'Client',
        email: 'Courriel',
        phone: 'Téléphone',
        title: 'Personnes-ressources du client'
      },
      actions: {
        exportAll: 'Tout exporter',
        exportPage: 'Exporter cette page',
        new: 'Nouvelle personne-ressource du client',
        exportToExcel: 'Exporter vers Excel'
      },
      errors: {
        retrieveClientContacts:
          'Une erreur est survenue dans la récupération de la liste des personnes-ressources du client'
      },
      filters: {
        title: 'Filtrer les personnes-ressources du client',
        all: 'Toutes les personnes-ressources du client',
        select: 'Sélectionner les personnes-ressources',
        activeinactive: {
          both: 'Les deux',
          active: 'Actif',
          inactive: 'Inactif'
        }
      }
    }
  },
  supplierContacts: {
    labels: {
      filter: 'Filtrer',
      active: 'Active',
      inactive: 'Inactive',
      both: 'Les deux',
      details: 'Details',
      history: 'Historique',
      firstName: 'Prénom',
      lastName: 'Nom de famille',
      preferredName: 'Nom préféré',
      supplier: 'Supplier',
      emails: 'Courriels',
      phoneNumbers: 'Numéros de téléphone',
      userAccount: 'Compte d’utilisateur'
    },
    listing: {
      title: 'Personnes-ressources du fournisseur',
      all: 'Toutes les personnes-ressources du fournisseur',
      labels: {
        reference_number: 'No de référence',
        display_name: 'Nom',
        supplier: 'Fournisseur',
        email: 'Courriel'
      },
      actions: {
        new: 'Créer une nouvelle personne-ressource du fournisseur',
        exportToExcel: 'Exporter vers Excel',
        exportAll: 'Tout exporter',
        exportPage: 'EExporter cette page'
      },
      errors: {
        retrieveSupplierContacts:
          'Une erreur est survenue dans la récupération de la liste de personnes-ressources du fournisseur'
      }
    },
    details: {
      supplierContact: 'Personne-ressource du fournisseur'
    }
  },
  recentItems: {
    listing: {
      title: 'Éléments consultés récemment',
      labels: {
        dateLastViewed: 'Date de dernière consultation',
        recentItem: 'Élément',
        recentItemType: 'Type'
      }
    },
    actions: {
      labels: {
        deleteRecentlyViewed: 'Supprimer tous les éléments consultés récemment'
      }
    },
    errors: {
      deleteRecentItems:
        'Une erreur est survenue dans la tentative de suppression d’un élément récent',
      retrieveRecentItems: 'Une erreur est survenue dans la récupération de d’un élément récent'
    }
  },

  users: {
    labels: {
      roles: 'Rôles de l’utilisateur',
      inactiveUser: 'Utilisateur inactif'
    },
    listing: {
      title: 'Utilisateurs',
      labels: {
        reference_number: 'Numéro de référence',
        username: 'Nom d’utilisateur',
        name: 'Nom',
        roles: 'Autres rôles'
      },
      errors: {
        retrieveUsers: "Une erreur est survenue dans la récupération de la liste d'utilisateurs"
      },
      filters: {
        title: 'Filtrer les utilisateurs',
        all: 'Sélectionner les utilisateurs'
      },
      actions: {
        title: 'Tous les utilisateurs'
      }
    }
  },

  purchaseOrders: {
    listing: {
      title: 'Bons de commande',
      labels: {
        reference_number: 'Numéro de référence',
        purchase_order_number: 'Numéro',
        client_name: 'Client',
        end_client_name: 'Client final',
        status: 'Statut',
        start_date: 'Date de début',
        end_date: 'Date de fin',
        funds_issued: 'Fonds envoyés',
        funds_remaining: 'Solde des fonds',
        percentage_remaining: 'Pourcentage restant',
        type: 'Type'
      },
      filters: {
        title: 'Filtrer les bons de commande',
        purchaseOrdersStatuses: {
          both: 'Les deux',
          active: 'Actif',
          closed: 'Fermé'
        },
        purchaseOrderColorTypes: {
          all: 'tous',
          green: 'vert',
          yellow: 'jaune',
          red: 'rouge'
        }
      }
    },
    assignments: {
      payRollNum: 'No de paie',
      contractor: 'Contractuel',
      client: 'Client',
      approvers: 'Approbateurs',
      startDate: 'Date de début',
      stopDate: 'Date de fin',
      branch: 'Succursale',
      status: 'Statut',
      referenceNumber: 'Numéro de référence'
    },
    history: {
      created_at: 'Date de modification',
      created_by_name: 'Modification par',
      status: 'Statut'
    },
    fullAuditTrial: {
      created_at: 'Date et utilisateur',
      item_number: 'No d’élément',
      unit_price: "Prix à l'Unité",
      quantity_delta: 'Différence de quantité',
      item_amount_remaining: "Nombre d'éléments restants",
      quantity_remaining: 'Quantité restante',
      unit_price_delta: 'Écart de dépenses',
      funds_remaining_po: 'Solde des fonds du bon de commande',
      action: 'Action et commentaire'
    },
    poItems: {
      item: "No d'élément",
      type: 'Type',
      Region: 'Région',
      UnitPrice: "Prix à l'unité",
      quantityIssued: 'Qté fournie',
      quantityRemanining: 'Qté restante',
      amount: 'Montant fourni',
      amountRemanining: 'Montant restant',
      percentRemaining: 'Pourcentage restant'
    },
    details: {
      title: 'Bon de commande',
      assignments: 'Mandats',
      purchaseOrderDetails: 'Détails',
      previousAssignments: 'Mandats précédents',
      poNumber: 'No de bon de commande',
      clientName: 'Client',
      clientNumber: 'No de client',
      endClient: 'Client final',
      fundsIssued: 'Fonds envoyés',
      fundsRemaning: 'Fonds restants',
      startDate: 'Date de début',
      endDate: 'Date de clôture',
      status: 'Statut',
      history: 'Historique',
      fullAuditTrial: 'Piste de vérification',
      podetails: 'Détails du bon de commande',
      fullaudit: 'Piste de vérification',
      filter: 'Filtrer',
      POStatuses: {
        Active: 'Actif',
        Closed: 'Fermé'
      },
      issue: 'Envoyer',
      save: 'Sauvegarder',
      deplete: 'Liquider',
      issueFunds: 'Envoyer les fonds',
      issueMessage: {
        message: 'Pour pouvoir retirer les fonds, il faut que cette valeur soit négative'
      },
      depleteFunds: 'Liquidation manuelle',
      depleteMessage: {
        message:
          'Pour pouvoir annuler une liquidation de fonds et en augmenter le solde, il faut que cette valeur soit négative'
      },
      lineItems: 'Aligner les éléments',
      errors: {
        retrievePurchaseOrder:
          'Une erreur est survenue dans la récupération de la liste de bons de commande'
      },
      warning: {
        issueFunds:
          "Comme ceci modifie la quantité de fonds envoyés, il ne faut pas s'en servir  pour faire une liquidation manuelle des fonds",
        depleteFunds:
          'Il faut recourir à une autre fonction pour faire une correction manuelle. La valeur de la liquidation de fonds correspond au montant facturé'
      }
    }
  },
  depositSlips: {
    listing: {
      title: 'Bordereaux de dépôt',
      depositNumber: 'Numéro de dépôt',
      endDate: 'Date de clôture de la période de paie',
      fileName: 'Nom du fichier'
    }
  },
  payrollOverviews: {
    listing: {
      title: 'Aperçu de la paie',
      labels: {
        created_at: 'Date de modification',
        created_by_name: 'Modification par',
        range_start: 'Début de la plage de temps',
        range_end: 'Fin de la plage de temps',
        departments: 'Services',
        pay_period: 'Période de paie',
        status: 'Statut'
      },
      actions: {
        titleAll: 'Tous les aperçus de paie',
        exportPage: 'Page actuelle',
        exportAll: 'Tous'
      },

      errors: {
        retrievePos: 'Une erreur est survenue dans la récupération de la liste des aperçus de paie',

        generatePos: "Une erreur est survenue dans la production de l'aperçu de la paie"
      }
    },
    details: {
      title: "Détails de l'aperçu de la paie",
      date_range: 'Plage de dates',
      departments: 'Services',
      pay_period: 'Période de paie',
      tol_generated: 'Produit par TOL',
      date: 'Date',
      user: 'Utilisateur',
      timesheets: 'Feuilles de temps',
      results: 'Résultats',
      processed: 'Traité',
      received: 'Reçu',
      ptb_processed: 'Traité par PTB',
      upload_results: 'Télécharger le fichier de résultats ci-dessous',
      download_export: "Télécharger le fichier d'exportation"
    }
  },
  reports: {
    title: 'Rapports',
    labels: {
      client: 'Client'
    },
    errors: {
      run_report: 'Une erreur est survenue dans la production du rapport'
    }
  },
  placementActivity: {
    title: "Activité d'embauche",
    errors: {
      retrievePlacementActivity:
        "Une erreur est survenue dans la récupération du rapport sur les activités d'embauche"
    }
  }
};
